import React from "react";
import { useTranslation } from "react-i18next";

// Matches Diamond-PO-Prototype-v3.html's addrCard()/route() exactly:
// two address cards (From/sender, To/receiver) joined by an arrow; a missing
// address renders as a red-dashed "No address on file" card naming whose it is.

const cardStyle = {
  border: "1px solid #e6e9f0",
  borderRadius: 8,
  padding: "10px 12px",
  fontSize: 12.5,
  lineHeight: 1.5,
  background: "#fbfcfe",
};

const missingCardStyle = {
  ...cardStyle,
  border: "1px dashed #e2574c",
  background: "#fff7f6",
  color: "#e2574c",
};

const labelStyle = {
  fontSize: 10,
  textTransform: "uppercase",
  letterSpacing: ".08em",
  color: "#6b7689",
  fontWeight: 700,
  marginBottom: 2,
};

const AddressCard = ({ address, title, partyName }) => {
  const { t } = useTranslation();
  if (!address) {
    return (
      <div style={missingCardStyle}>
        <div style={{ ...labelStyle, color: "#e2574c" }}>{title}</div>
        <b>{t("No address on file")}</b>
        <div className="sub">{t("{{party}} must add one before this can proceed", { party: partyName })}</div>
      </div>
    );
  }
  return (
    <div style={cardStyle}>
      <div style={labelStyle}>{title}</div>
      <b>{partyName}</b>
      <div>
        {address.Label} · {address.ContactName}
      </div>
      <div>{address.Address}</div>
      <div>
        {address.City}, {address.State} {address.Zip} · {address.Country}
      </div>
      <div className="sub" style={{ color: "#6b7689" }}>
        {address.Phone}
      </div>
    </div>
  );
};

export const RouteCard = ({ fromAddress, toAddress, fromPartyName, toPartyName }) => {
  const { t } = useTranslation();
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 34px 1fr", gap: 8, alignItems: "stretch" }}>
      <AddressCard address={fromAddress} title={t("From · sender")} partyName={fromPartyName} />
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20, color: "#3b5bdb" }}>→</div>
      <AddressCard address={toAddress} title={t("To · receiver")} partyName={toPartyName} />
    </div>
  );
};

export default RouteCard;
